import {
  CarFilter,
  FeatureFilter,
  FiltersTypes,
} from '@/types/filters/filters.types';

export const fuelTypeOptions: CarFilter[] = [
  {
    id: 1,
    type: FiltersTypes.fuel,
    name: 'Petrol',
    fullName: 'Petrol',
    isSelected: false,
  },
  {
    id: 2,
    type: FiltersTypes.fuel,
    name: 'Diesel',
    fullName: 'Diesel',
    isSelected: false,
  },
  {
    id: 3,
    type: FiltersTypes.fuel,
    name: 'Hybrid',
    fullName: 'Hybrid',
    isSelected: false,
  },
];

export const transmissionTypeOptions: CarFilter[] = [
  {
    id: 1,
    type: FiltersTypes.transmission,
    name: 'Automatic',
    fullName: 'Automatic',
    isSelected: false,
  },
  {
    id: 2,
    type: FiltersTypes.transmission,
    name: 'Manual',
    fullName: 'Manual',
    isSelected: false,
  },
];

export const searchLocationTypeOptions: CarFilter[] = [
  {
    id: 1,
    type: FiltersTypes.province,
    name: 'Western Cape',
    fullName: 'Western Cape',
    isSelected: false,
  },
  {
    id: 2,
    type: FiltersTypes.province,
    name: 'Gauteng',
    fullName: 'Gauteng',
    isSelected: false,
  },
  {
    id: 3,
    type: FiltersTypes.province,
    name: 'Kwazulu Natal',
    fullName: 'Kwazulu Natal',
    isSelected: false,
  },
];

export const searchMileageTypeOptions: CarFilter[] = [
  {
    id: 1,
    type: FiltersTypes.mileage,
    name: '50000km',
    fullName: '50000km',
    isSelected: false,
  },
  {
    id: 2,
    type: FiltersTypes.mileage,
    name: '100000km',
    fullName: '100000km',
    isSelected: false,
  },
  {
    id: 3,
    type: FiltersTypes.mileage,
    name: '150000km',
    fullName: '150000km',
    isSelected: false,
  },
  {
    id: 4,
    type: FiltersTypes.mileage,
    name: '200000km',
    fullName: '200000km',
    isSelected: false,
  },
  {
    id: 5,
    type: FiltersTypes.mileage,
    name: '250000km',
    fullName: '250000km',
    isSelected: false,
  },
  {
    id: 6,
    type: FiltersTypes.mileage,
    name: '300000km',
    fullName: '300000km',
    isSelected: false,
  },
];

export const searchPriceTypeOptions: CarFilter[] = [
  {
    id: 1,
    type: FiltersTypes.price,
    name: 'R100000',
    fullName: 'R100000',
    isSelected: false,
  },
  {
    id: 2,
    type: FiltersTypes.price,
    name: 'R150000',
    fullName: 'R150000',
    isSelected: false,
  },
  {
    id: 3,
    type: FiltersTypes.price,
    name: 'R200000',
    fullName: 'R200000',
    isSelected: false,
  },
  {
    id: 4,
    type: FiltersTypes.price,
    name: 'R250000',
    fullName: 'R250000',
    isSelected: false,
  },
  {
    id: 5,
    type: FiltersTypes.price,
    name: 'R300000',
    fullName: 'R300000',
    isSelected: false,
  },
  {
    id: 6,
    type: FiltersTypes.price,
    name: 'R350000',
    fullName: 'R350000',
    isSelected: false,
  },
  {
    id: 7,
    type: FiltersTypes.price,
    name: 'R400000',
    fullName: 'R400000',
    isSelected: false,
  },
  {
    id: 8,
    type: FiltersTypes.price,
    name: 'R450000',
    fullName: 'R450000',
    isSelected: false,
  },
  {
    id: 9,
    type: FiltersTypes.price,
    name: 'R500000',
    fullName: 'R500000',
    isSelected: false,
  },
  {
    id: 10,
    type: FiltersTypes.price,
    name: 'R1000000',
    fullName: 'R1000000',
    isSelected: false,
  },
];

export const searchYearTypeOptions: CarFilter[] = [
  {
    id: 1,
    type: FiltersTypes.year,
    name: '2021',
    fullName: '2021',
    isSelected: false,
  },
  {
    id: 2,
    type: FiltersTypes.year,
    name: '2020',
    fullName: '2020',
    isSelected: false,
  },
  {
    id: 3,
    type: FiltersTypes.year,
    name: '2019',
    fullName: '2019',
    isSelected: false,
  },
  {
    id: 4,
    type: FiltersTypes.year,
    name: '2018',
    fullName: '2018',
    isSelected: false,
  },
  {
    id: 5,
    type: FiltersTypes.year,
    name: '2017',
    fullName: '2017',
    isSelected: false,
  },
  {
    id: 6,
    type: FiltersTypes.year,
    name: '2016',
    fullName: '2016',
    isSelected: false,
  },
  {
    id: 7,
    type: FiltersTypes.year,
    name: '2015',
    fullName: '2015',
    isSelected: false,
  },
  {
    id: 8,
    type: FiltersTypes.year,
    name: '2014',
    fullName: '2014',
    isSelected: false,
  },
  {
    id: 9,
    type: FiltersTypes.year,
    name: '2013',
    fullName: '2013',
    isSelected: false,
  },
  {
    id: 10,
    type: FiltersTypes.year,
    name: '2012',
    fullName: '2012',
    isSelected: false,
  },
  // {
  //   id: 11,
  //   type: FiltersTypes.year,
  //   name: '2011',
  //   fullName: '2011',
  //   isSelected: false,
  // },
  // {
  //   id: 12,
  //   type: FiltersTypes.year,
  //   name: '2010',
  //   fullName: '2010',
  //   isSelected: false,
  // },
  // {
  //   id: 13,
  //   type: FiltersTypes.year,
  //   name: '2009',
  //   fullName: '2009',
  //   isSelected: false,
  // },
  // {
  //   id: 14,
  //   type: FiltersTypes.year,
  //   name: '2008',
  //   fullName: '2008',
  //   isSelected: false,
  // },
  // {
  //   id: 15,
  //   type: FiltersTypes.year,
  //   name: '2007',
  //   fullName: '2007',
  //   isSelected: false,
  // },
  // {
  //   id: 16,
  //   type: FiltersTypes.year,
  //   name: '2006',
  //   fullName: '2006',
  //   isSelected: false,
  // },
  // {
  //   id: 17,
  //   type: FiltersTypes.year,
  //   name: '2005',
  //   fullName: '2005',
  //   isSelected: false,
  // },
  // {
  //   id: 18,
  //   type: FiltersTypes.year,
  //   name: '2004',
  //   fullName: '2004',
  //   isSelected: false,
  // },
  // {
  //   id: 19,
  //   type: FiltersTypes.year,
  //   name: '2003',
  //   fullName: '2003',
  //   isSelected: false,
  // },
  // {
  //   id: 20,
  //   type: FiltersTypes.year,
  //   name: '2002',
  //   fullName: '2002',
  //   isSelected: false,
  // },
  // {
  //   id: 21,
  //   type: FiltersTypes.year,
  //   name: '2001',
  //   fullName: '2001',
  //   isSelected: false,
  // },
  // {
  //   id: 22,
  //   type: FiltersTypes.year,
  //   name: '2000',
  //   fullName: '2000',
  //   isSelected: false,
  // },
];

export const driveTypeOptions: CarFilter[] = [
  {
    id: 1,
    type: FiltersTypes.drivetrain,
    name: 'Front Wheel',
    fullName: 'Front Wheel',
    isSelected: false,
  },
  {
    id: 3,
    type: FiltersTypes.drivetrain,
    name: 'All Wheel',
    fullName: 'All Wheel',
    isSelected: false,
  },
  {
    id: 2,
    type: FiltersTypes.drivetrain,
    name: 'Rear Wheel',
    fullName: 'Rear Wheel',
    isSelected: false,
  },
  {
    id: 4,
    type: FiltersTypes.drivetrain,
    name: '4x4',
    fullName: '4x4',
    isSelected: false,
  },
];

export const comfortOptions: FeatureFilter[] = [
  {
    id: -1,
    type: FiltersTypes.features,
    name: 'Heated Seats',
    fullName: 'Heated Seats',
    isSelected: false,
  },
  {
    id: -2,
    type: FiltersTypes.features,
    name: 'Electric Seats',
    fullName: 'Electric Seats',
    isSelected: false,
  },
  {
    id: -3,
    type: FiltersTypes.features,
    name: 'Sun roof Electric',
    fullName: 'Sun roof Electric',
    isSelected: false,
  },
  {
    id: -4,
    type: FiltersTypes.features,
    name: 'Sun roof Manual',
    fullName: 'Sun roof Manual',
    isSelected: false,
  },
];

export const safetyAndTechOptions: FeatureFilter[] = [
  {
    id: -5,
    type: FiltersTypes.features,
    name: 'Parking Sensors',
    fullName: 'Parking Sensors',
    isSelected: false,
  },
  {
    id: -6,
    type: FiltersTypes.features,
    name: 'Isofix Child Seat Fitting',
    fullName: 'Isofix Child Seat Fitting',
    isSelected: false,
  },
  {
    id: -7,
    type: FiltersTypes.features,
    name: 'Rear View Camera',
    fullName: 'Rear View Camera',
    isSelected: false,
  },
  {
    id: -8,
    type: FiltersTypes.features,
    name: 'Sat Nav',
    fullName: 'Sat Nav',
    isSelected: false,
  },
];

export const otherOptions: FeatureFilter[] = [
  {
    id: 49,
    type: FiltersTypes.features,
    name: 'ABS',
    fullName: 'ABS',
    isSelected: false,
  },
  {
    id: 8,
    type: FiltersTypes.features,
    name: 'Alloy Wheels',
    fullName: 'Alloy Wheels',
    isSelected: false,
  },
  {
    id: 2,
    type: FiltersTypes.features,
    name: 'Airbags',
    fullName: 'Airbags',
    isSelected: false,
  },
  {
    id: 16,
    type: FiltersTypes.features,
    name: 'EBD',
    fullName: 'EBD',
    isSelected: false,
  },
  {
    id: 46,
    type: FiltersTypes.features,
    name: 'Radio / CD',
    fullName: 'Radio / CD',
    isSelected: false,
  },
  {
    id: 5,
    type: FiltersTypes.features,
    name: 'Central Locking ',
    fullName: 'Central Locking ',
    isSelected: false,
  },
  {
    id: 43,
    type: FiltersTypes.features,
    name: 'Electric Windows',
    fullName: 'Electric Windows',
    isSelected: false,
  },
  {
    id: 1,
    type: FiltersTypes.features,
    name: 'Air Conditioning',
    fullName: 'Air Conditioning',
    isSelected: false,
  },
  {
    id: 50,
    type: FiltersTypes.features,
    name: 'Full Size Spare Wheel',
    fullName: 'Full Size Spare Wheel',
    isSelected: false,
  },
  {
    id: 61,
    type: FiltersTypes.features,
    name: 'Height adjustable Drivers Seat',
    fullName: 'Height adjustable Drivers Seat',
    isSelected: false,
  },
  {
    id: 51,
    type: FiltersTypes.features,
    name: 'Vanity mirrors ',
    fullName: 'Vanity mirrors ',
    isSelected: false,
  },
  {
    id: 13,
    type: FiltersTypes.features,
    name: 'Bluetooth connectivity ',
    fullName: 'Bluetooth connectivity ',
    isSelected: false,
  },
  {
    id: 52,
    type: FiltersTypes.features,
    name: 'Split Folding Rear Seats ',
    fullName: 'Split Folding Rear Seats ',
    isSelected: false,
  },
  {
    id: 53,
    type: FiltersTypes.features,
    name: 'Electric Mirrors',
    fullName: 'Electric Mirrors',
    isSelected: false,
  },
  {
    id: 54,
    type: FiltersTypes.features,
    name: 'Trip / Fuel Computer ',
    fullName: 'Trip / Fuel Computer ',
    isSelected: false,
  },
  {
    id: 55,
    type: FiltersTypes.features,
    name: 'Body Coloured Bumpers ',
    fullName: 'Body Coloured Bumpers ',
    isSelected: false,
  },
  {
    id: 56,
    type: FiltersTypes.features,
    name: 'Android Auto compatibility',
    fullName: 'Android Auto compatibility',
    isSelected: false,
  },
  {
    id: 57,
    type: FiltersTypes.features,
    name: 'Apple Carplay compatiblility',
    fullName: 'Apple Carplay compatiblility',
    isSelected: false,
  },
  {
    id: 38,
    type: FiltersTypes.features,
    name: 'In Car Navigation System ',
    fullName: 'In Car Navigation System ',
    isSelected: false,
  },
  {
    id: 58,
    type: FiltersTypes.features,
    name: 'Voice Command',
    fullName: 'Voice Command',
    isSelected: false,
  },
  {
    id: 59,
    type: FiltersTypes.features,
    name: 'Drive Mode Selection',
    fullName: 'Drive Mode Selection',
    isSelected: false,
  },
  {
    id: 23,
    type: FiltersTypes.features,
    name: 'Keyless Entry ',
    fullName: 'Keyless Entry ',
    isSelected: false,
  },
  {
    id: 11,
    type: FiltersTypes.features,
    name: 'Reverse Camera ',
    fullName: 'Reverse Camera ',
    isSelected: false,
  },
  {
    id: 62,
    type: FiltersTypes.features,
    name: 'Leather Upholstery ',
    fullName: 'Leather Upholstery ',
    isSelected: false,
  },
  {
    id: 36,
    type: FiltersTypes.features,
    name: 'Park Distance Control sensors',
    fullName: 'Park Distance Control sensors',
    isSelected: false,
  },
  {
    id: 60,
    type: FiltersTypes.features,
    name: 'Fog Lights',
    fullName: 'Fog Lights',
    isSelected: false,
  },
  {
    id: 6,
    type: FiltersTypes.features,
    name: 'Sunroof',
    fullName: 'Sunroof',
    isSelected: false,
  },
  {
    id: 44,
    type: FiltersTypes.features,
    name: 'Day Time Driving Lights',
    fullName: 'Day Time Driving Lights',
    isSelected: false,
  },
];

export const BRAND_LIST_REQUEST_FIELDS = ['id', 'name', 'code', 'logo'];

export const BRAND_AND_RANGES_REQUEST_FIELDS = [
  'id',
  'name',
  'code',
  'logo',
  'vehicles.dealership_id',
  'vehicles.type',
  'vehicles.status',
  'vehicles.popularity',
  'vehicles.is_konfidence',
  'vehicles.sale_end_date',
  'specials.status',
  'specials.id',
  'specials.start_date',
  'specials.end_date',
  'range_ids.id',
  'range_ids.name',
  'range_ids.code',
  'range_ids.popularity',
  'range_ids.vehicles.dealership_id',
  'range_ids.vehicles.status',
  'range_ids.vehicles.popularity',
  'range_ids.vehicles.type',
  'range_ids.vehicles.is_konfidence',
  'range_ids.vehicles.sale_end_date',
];

export const BRAND_NAMES_REQUEST_FIELDS = ['name', 'vehicles.status'];

export const BRAND_POPULAR_REQUEST_FIELDS = [
  'name',
  'id',
  'code',
  'logo',
  'vehicles.popularity',
];

export const HEADER_BRANDS_FIELDS = ['id', 'name', 'logo'];

export const FOOTER_BRANDS_FIELDS = ['name', 'code'];
export const FOOTER_CARS_FIELDS = ['main_title', 'slug'];

export const AVAILABLE_BRANDS_FIELDS = [
  'name',
  'id',
  'logo',
  'vehicles.id',
  'vehicles.spec_body_type',
  'vehicles.status',
  'vehicles.type',
  'vehicles.dealership_id.province',
  'vehicles.display_price',
  'vehicles.is_konfidence',
];

export const BRAND_AND_RANGES_NAMES_REQUEST_FIELDS = [
  ...BRAND_NAMES_REQUEST_FIELDS,
  'range_ids.name',
  'range_ids.vehicles.status',
];
